const SET_LOADING = 'ui/SET_LOADING';

const uiActionTypes = {
  SET_LOADING,
};

export default uiActionTypes;
